import { createContext, useState, useContext } from 'react';

const FeedbackContext = createContext({
  isOpen: false,
  openFeedback: () => {},
  closeFeedback: () => {}
});

export function FeedbackProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openFeedback = () => setIsOpen(true);
  const closeFeedback = () => setIsOpen(false);

  return (
    <FeedbackContext.Provider value={{ isOpen, openFeedback, closeFeedback }}>
      {children}
    </FeedbackContext.Provider>
  );
}

export function useFeedback() {
  return useContext(FeedbackContext);
}

export default FeedbackContext;
